//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 10.09.2015.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .filter('zeroPadIndex', zeroPadIndex)
        .filter('fileSize', fileSize)
        .filter('duration', duration);

    function zeroPadIndex() {
        return function (index, elementCount) {
            return ('000000000' + index).substr(-elementCount.toString().length);
        };
    }

    function fileSize(FileSizeUnit) {

        return (size, unit, decimals) => {

            if (!unit) unit = getUnitForSize(size);

            if (!decimals) decimals = 2;

            let unitInfo = (() => {
                switch (unit) {
                    case FileSizeUnit.KB: default: return {coeff: 1024, label: 'KB'};
                    case FileSizeUnit.MB: return {coeff: Math.pow(1024, 2), label: 'MB'};
                    case FileSizeUnit.GB: return {coeff: Math.pow(1024, 3), label: 'GB'};
                    case FileSizeUnit.TB: return {coeff: Math.pow(1024, 4), label: 'TB'};
                }
            })();

            return `${(size / unitInfo.coeff).toFixed(decimals)} ${unitInfo.label}`;
        };

        function getUnitForSize(size) {

            if (!size || size < Math.pow(1024, 2))
                return FileSizeUnit.KB;

            if (size < Math.pow(1024, 3))
                return FileSizeUnit.MB;

            if (size < Math.pow(1024, 4))
                return FileSizeUnit.GB;

            return FileSizeUnit.TB;
        }
    }

    function duration() {

        return duration => {

            let moDuration = moment.duration(duration);
            return moDuration.format('h:mm:ss.SSS', {trim: false});
        };
    }
})();

